<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "StopLocationIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
